import { createRouter, createWebHashHistory } from "vue-router";
const routes = [
  {
    path: '/', name: 'home',
    component: () => import('../views/home/index.vue')
  },
  {
    path: '/404', component: () => import('@/views/404/index.vue')
  }
]
// '/cashierDesk/'
const router = createRouter({
  history: createWebHashHistory(process.env.VUE_APP_BASE_URL),
  routes
})
export default router
